import { Img } from '@chakra-ui/react';
import React from 'react';
import sagitariusLogoProduction from './production-logo.svg';
import sagitariusSmallLogoProduction from './production-logo-small.png';

export const SagitariusLogo = () => <Img height="24px" src={sagitariusLogoProduction} alt="sagitarius-logo" />;
export const SagitariusLogoSmall = () => (
    <Img height="20px" src={sagitariusSmallLogoProduction} alt="sagitarius-logo-small" />
);
